"use strict";
var fails = require("../internals/fails");
module.exports = !fails(function() {
  var test = function() {
  }.bind();
  return typeof test != "function" || test.hasOwnProperty("prototype");
});
